import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { KidsHotelStore } from './kids-hotel/kids-hotel.store';
import { KidsCodetableStore } from './kids-codetable.store';
import { KidsTermineStore } from './kids-termine/kids-termine.store';

// Resolver der das Laden von relevanten Kids Daten sicherstellt (Hotels, Codetable Items, Termine)

export const kidsDatenResolver: ResolveFn<void> = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const hotelStore = inject(KidsHotelStore);
  const codetableStore = inject(KidsCodetableStore);
  const terminStore = inject(KidsTermineStore);
  await Promise.all([hotelStore.load(), codetableStore.load(), terminStore.load()]);
};
